import { Icons, useHelmet } from '@agro-club/agroclub-shared'
import { endpoints } from 'modules/endpoints'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import ATableFullPage from 'views/components/Table/ATableFullPage'
import * as Layout from 'views/layouts/NewLayout'
import * as Header from 'views/ui/Header/Header'
import { useFilters } from 'hooks/useFilter'
import { ListRequestParams } from 'modules/domain/types'
import useColumns from './useColumns'
import { defaultListRequestParams } from 'views/components/TableFilters/data'
import { AButton } from 'views/components/Analytics'
import { AddElevatorModal } from './AddElevatorModal'
import { elevatorsDefaultFilters, ElevatorsFilters } from './ElevatorsFilters'

export const ElevatorList: FC = () => {
  const { t } = useTranslation('warehouses')
  useHelmet({ title: t('elevators') })
  const [listRequestParams, setListRequestParams] = useState<ListRequestParams>({
    ...defaultListRequestParams,
    filter: { ...elevatorsDefaultFilters },
  })
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  const { isFiltersLoaded, updateFilterState } = useFilters({
    listRequestParams,
    setListRequestParams,
  })
  const refetch = () => setListRequestParams((prev) => ({ ...prev }))

  const columns = useColumns()

  return (
    <APageWrapper page="elevatorList" place="elevatorList">
      <Layout.WrapperContent>
        <Layout.Header>
          <Layout.TopHeader>
            <Header.Breadcrumbs routes={[{ breadcrumbName: t('elevators') }]} />
            <AButton id="add" Icon={Icons.IconAdd} color="approve" size="medium" onClick={() => setIsModalOpen(true)}>
              {t('common:add')}
            </AButton>
          </Layout.TopHeader>
          <Layout.PageName>{t('elevators')}</Layout.PageName>
          <ElevatorsFilters
            setListRequestParams={setListRequestParams}
            listRequestParams={listRequestParams}
            updateFilterState={updateFilterState}
          />
        </Layout.Header>

        <ATableFullPage
          listParamsUpdated={setListRequestParams}
          listRequestParams={listRequestParams}
          dataEndpoint={endpoints.elevators()}
          isFiltersLoaded={isFiltersLoaded}
          columns={columns}
          rowHoverGray
        />
      </Layout.WrapperContent>
      {isModalOpen && <AddElevatorModal onClose={() => setIsModalOpen(false)} onSuccess={refetch} />}
    </APageWrapper>
  )
}
